import React, { useState } from "react";
import { Button, useToast } from "@veneer/core";
import { updatePrinthead } from "../../../../api/printheadUpdate";

const ResultTable = ({ initialCaseId, initialCodeAuthorize, apiData ,tokeninfo}) => {
    const { addToast } = useToast();

    // State for managing the case ID and code to authorize
    const [caseId, setCaseId] = useState(apiData.case_id || initialCaseId);
    const [printheadCode, setPrintheadCode] = useState(apiData.printhead_code || initialCodeAuthorize);
    const [caseIdError, setCaseIdError] = useState('');
    const role = tokeninfo.profile

    const handleCopyToClipboard = () => {
        const textToCopy = `
            Case ID: ${caseId}
            Code to authorize: ${printheadCode}
            Printer SN / phType: ${apiData.printer_sn} / ${apiData.ph_type}
            Date: ${new Date(apiData.warranty_date).toDateString()}
            Printhead SN: ${apiData.printhead_sn}
            Warranty status: ${apiData.warranty_status}
            Altered ink: ${apiData.altered_ink ? 'Yes' : 'No'}
            Non-HP ink: ${apiData.non_hp_ink ? 'Yes' : 'No'}
            Expired ink: ${apiData.expired_ink ? 'Yes' : 'No'}
            Ink limit: ${apiData.ink_limit ? 'Yes' : 'No'}
            Time limit: ${apiData.time_limit ? 'Yes' : 'No'}
            Error status: ${apiData.error_status}
            Electrical: ${apiData.electrical ? 'Yes' : 'No'}
            Thermal: ${apiData.thermal ? 'Yes. Thermal' : 'No'}
            Acumen: ${apiData.acumen ? 'Yes' : 'No'}
            Many nozzles out: ${apiData.many_nozzles_out ? 'Yes' : 'No'}
        `;
        navigator.clipboard.writeText(textToCopy).then(() => {
            addToast({
                text: 'Text copied to clipboard',
                type: 'positive',
                timeout: 5,
            });
        }).catch((err) => {
            console.error("Failed to copy: ", err);
        });
    };
    const handleCaseIdChange = (e) => {
        const value = e.target.value;
        const numericValue = value.replace(/[^0-9]/g, '');
        setCaseId(numericValue);
    };


    const handleSubmit = async () => {
        if (!caseId.trim()) {
            setCaseIdError('Case ID is required');
            return;
        }

        setCaseIdError(''); // Clear any previous errors

        try {
            const data = await updatePrinthead(caseId, printheadCode);
            addToast({
                text: data.message,
                type: 'positive',
                timeout: 5,
            });
        } catch (error) {
            addToast({
                text: 'Failed to update printhead',
                type: 'negative',
                timeout: 5,
            });
        }
    };

    return (
        <div className="result-container">
            <h2 className="result-title">Printhead Service Code</h2>
            {(role === '3' || role === '1') && (
            <div className="form-group">
                <label htmlFor="case-id-result" className="form-label">
                    Case ID<span style={{color: 'red'}}>*</span>
                </label>
                <input
                    id="case-id-result"
                    type="text"
                    value={caseId}
                    onChange={handleCaseIdChange}
                    className="form-input"
                />
            </div>
            )}
            {caseIdError && <p className="error-message" style={{color: 'red',marginLeft:150}}>{caseIdError}</p>}
            <div className="form-group">
                <label htmlFor="code-authorize-result" className="form-label">
                    Code to authorize<span style={{color: 'red'}}>*</span>
                </label>
                <input
                    id="code-authorize-result"
                    type="text"
                    readOnly
                    value={printheadCode}
                    onChange={(e) => setPrintheadCode(e.target.value)} // Update state on change
                    className="form-input"
                />
            </div>
            <table className="result-table">
                <tbody>
                <tr>
                    <td>Printer SN / phType:</td>
                    <td>{apiData.printer_sn} / {apiData.ph_type}</td>
                </tr>
                <tr>
                    <td>Date:</td>
                    <td>{new Date(apiData.warranty_date).toDateString()}</td>
                </tr>
                <tr>
                    <td>Printhead SN:</td>
                    <td>{apiData.printhead_sn}</td>
                </tr>
                <tr>
                    <td>Warranty status:</td>
                    <td className="text-green">{apiData.warranty_status}</td>
                </tr>
                <tr>
                    <td>Altered ink:</td>
                    <td>{apiData.altered_ink ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Non-HP ink:</td>
                    <td>{apiData.non_hp_ink ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Expired ink:</td>
                    <td>{apiData.expired_ink ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Ink limit:</td>
                    <td>{apiData.ink_limit ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Time limit:</td>
                    <td>{apiData.time_limit ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Error status:</td>
                    <td className="text-red">{apiData.error_status}</td>
                </tr>
                <tr>
                    <td>Electrical:</td>
                    <td>{apiData.electrical ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Thermal:</td>
                    <td className="text-red">{apiData.thermal ? 'Yes. Thermal' : 'No'}</td>
                </tr>
                <tr>
                    <td>Acumen:</td>
                    <td>{apiData.acumen ? 'Yes' : 'No'}</td>
                </tr>
                <tr>
                    <td>Many nozzles out:</td>
                    <td>{apiData.many_nozzles_out ? 'Yes' : 'No'}</td>
                </tr>
                </tbody>
            </table>
            <div className="button-container" style={{ display: 'flex', justifyContent: 'space-between' }}>
                <Button
                    appearance="primary"
                    onClick={handleSubmit}
                    disabled={!caseId.trim() || (role !== '1' && role !== '3')}
                >
                    Submit
                </Button>
                <Button
                    appearance="primary"
                    style={{
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        cursor: 'pointer',
                        padding: '10px 20px',
                        marginLeft: '100px',
                    }}
                    onClick={handleCopyToClipboard}
                >
                    Copy to clipboard
                </Button>
            </div>
        </div>
    );
};

export default ResultTable;
